import { declOfNum } from '../../../../helpers/dspx-utils';
import getName from '../../../../helpers/getName';

const properties = [
  { name: 'id', flex: 0.3, highlight: true, header: '№' },
  {
    name: 'name',
    flex: 2,
    highlight: true,
    header: 'Наименование/ ФИО',
    customCellContent: (counterparty) =>
      counterparty.name || getName(counterparty),
  },
  {
    name: 'createWorker',
    flex: 1,
    customCellContent: (counterparty) => getName(counterparty.createWorker),
    header: 'Ответственное лицо',
  },
  { name: 'type.name', flex: 1, header: 'Тип' },
  {
    name: 'legalEntityInfo',
    flex: 1,
    customCellContent: (counterparty) => {
      const { type, legalEntityInfo } = counterparty;
      const isLegalEntityInfo =
        type.name === 'юридическое лицо' && legalEntityInfo;

      if (isLegalEntityInfo) {
        return `${counterparty.legalEntityInfo.inn || '-'}/${
          counterparty.legalEntityInfo.ogrn || '-'
        }`;
      } else {
        return '-';
      }
    },
    header: 'ИНН/ ОГРН',
  },
  {
    name: 'attachments',
    flex: 1,
    customCellContent: (counterparty) => {
      return `${counterparty.attachments?.length || '0'} ${declOfNum(
        counterparty.attachments?.length,
        ['вложение', 'вложения', 'вложений']
      )}`;
    },
    header: 'Документы',
  },
];

export default properties;
